//
export default [
    {
        text: 'código de proveedor',
        value: 'provider_product_code',
        input: {
            type: 'text-field',
        },
        width: '10%',
    },
    {
        text: 'código interno',
        value: 'wh_product_internal_code',
        width: '10%',
    },
    {
        text: 'alias',
        value: 'wh_product_alias_name',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'wh_product_name',
    },
    {
        text: 'stock bodega',
        value: 'stock',
        align: 'right',
        width: '10%',
    },
    {
        text: 'stock sucursal',
        value: 'stock_branch',
        align: 'right',
        width: '10%',
    },
    {
        text: 'recepcionado',
        value: 'received',
        align: 'right',
        format: 'number',
        width: '10%',
    },
    {
        text: 'precio neto',
        value: 'net_price',
        input: {
            type: 'currency-field',
            reverse: true,
        },
        align: 'right',
        format: 'currency',
        width: '10%',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        input: {
            type: 'float-field',
            reverse: true,
        },
        align: 'right',
        format: 'number',
        width: '10%',
    },
]
